document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.contact-us__form input[type="email"]').forEach(function (input) {
    input.addEventListener('blur', function () {
      input.reportValidity();
    });
    input.addEventListener('input', function () {
      if (!input.validity.valid) {
        input.reportValidity();
      }
    });
  });

  var status = document.querySelector('.contact-us__form .contact-msg');
  if (status) {
    status.scrollIntoView({ behavior: 'smooth', block: 'center' });
    status.focus({ preventScroll: true });
  }
});
